<div
  style="
    order: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  "
>
  <div class="map-container-2">
    <app-mapa-facil class="mapita"></app-mapa-facil>
  </div>
  <div
    style="
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      width: 17.5%;
      margin-left: 10px;
    "
  >
    <app-activo-recorrido
      [activo]="this.activo"
      (interaccionesBusquedaSelectedChange)="armarRecorridoParaMapa($event)"
    ></app-activo-recorrido>
  </div>
</div>
<!-- </div> -->
